export default __webpack_public_path__ + "3428091b317453ace1cd4cd70597ae83.svg";